import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  LinearProgress,
  Stack,
  TextField,
  Theme,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { useAppSelector, useAppDispatch } from "../../../app/hooks";

import Toast from "../../../components/Layout/Toast";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Share } from "@mui/icons-material";
import { StyledLink } from "../../../styles/componentStyled";
import { selectProcesses, shareByEmail } from "../processSlices";

interface LinkProp {
  link: string;
  employees: string;
  isPremium?: boolean;
}
const ShareCvs = ({ link, employees, isPremium }: LinkProp) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );
  const [email, setEmail] = useState("");
  const { t } = useTranslation();
  const {
    error,
    success,
    loading: shareByEmailLoading,
  } = useAppSelector(selectProcesses);
  const isEmailValid =
    email.length === 0 ||
    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);

  const dispatch = useAppDispatch();
  const shareLinkByEmail = () => {
    dispatch(shareByEmail({ link: isPremium ? "ccp/" + link : link, email }));
  };
  return (
    <Card>
      <CardHeader subheader={t("share")} title={t("shareLinks")} />
      <Divider />
      <CardContent>
        <TextField
          fullWidth
          sx={{ mt: 1 }}
          name="link"
          value={link}
          label={t("link")}
          disabled
        />
        <TextField
          fullWidth
          sx={{ mt: 1 }}
          name="employees"
          value={employees}
          label={t("employees")}
          disabled
        />
        <TextField
          fullWidth
          sx={{ mt: 1 }}
          name="email"
          label={t("email")}
          value={email}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setEmail(event.target.value);
          }}
          error={!isEmailValid as boolean}
          helperText={!isEmailValid ? "Email is not correct" : ""}
        />
        <Box m={1}>
          {shareByEmailLoading === "pending" && (
            <LinearProgress color="secondary" />
          )}
          {error && <Toast severity="error">{error.message}</Toast>}
          {success && <Toast severity="success">{success.message}</Toast>}
        </Box>
      </CardContent>
      <Divider />
      <Stack
        direction={isSmallScreen ? "column" : "row"}
        spacing={1}
        sx={{
          justifyContent: "space-between",
          p: 2,
          margin: "auto",
          marginBottom: theme.spacing(2),
        }}
      >
        <Button
          onClick={shareLinkByEmail}
          color="secondary"
          variant="contained"
          disabled={!isEmailValid || email.length === 0}
        >
          <Share /> {t("shareByEmail")}
        </Button>
        <StyledLink
          aria-label="Chat on WhatsApp"
          href={`https://wa.me/?text=https://enjazplus.com/${
            isPremium ? "c/ccp" : "c"
          }/${link}?lng=ar`}
          target={"_blank"}
          sx={{
            padding: "8px",
            color: "white",
            backgroundColor: "#075E54",
            borderRadius: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {" "}
          <img
            alt="Chat on WhatsApp"
            src="/Digital_Glyph_White.svg"
            width="50px"
            height="30px"
          />
          {t("shareByWhatsApp")}
        </StyledLink>{" "}
      </Stack>
    </Card>
  );
};

export default ShareCvs;
